export default "__VITE_ASSET__0d2a780b__"